import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Component } from '@angular/core';
import { ThemeService } from '../../services/theme/theme.service';
import { ContactComponent } from '../../../features/contact/contact.component';
import { PopupService } from '../../services/popup/popup.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LegalInformationPopupComponent } from '../legal-information-popup/legal-information-popup.component';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.sass'],
    standalone: false
})

export class FooterComponent {

  dialogRef: MatDialogRef<ContactComponent> | undefined;

  constructor(private themeService: ThemeService,private popupService: PopupService) { }

  get currentYear() {
    return new Date().getFullYear();
  }

  getThemeMode(): string {
    return this.themeService.getThemeMode();
  }

  openContactPopup() {
    this.dialogRef = this.popupService.openDialog(ContactComponent)
  }

  openLegalInformations() {
    this.dialogRef = this.popupService.openDialog(LegalInformationPopupComponent)
  }

  closeDialog() {
    this.dialogRef?.close();
  }

}